const defaultLayout = 'expanded';
const layoutStorageKey = {
  slots: 'dataGrid_apiPage_slots',
  props: 'dataGrid_apiPage_props',
  classes: 'dataGrid_apiPage_classes',
} as const;

export default { defaultLayout, layoutStorageKey };
